import React from 'react';

import { useSelector } from 'react-redux';
import { okrsPageSelector } from 'selectors/okrsPage';

import { GROUP_BY_OBJECTIVE_KEY_OBJ, SPLIT_BY_NONE_KEY_OBJ } from '.';
import GoalsClickThroughTable from './GoalsClickThroughTable';

const ClickThroughObjectiveTable = ({ selectedCohort }) => {
  const {
    selectedTimelines,
    insights: { clickThroughViewData },
  } = useSelector(okrsPageSelector);

  return (
    <GoalsClickThroughTable
      selectedCohort={selectedCohort}
      selectedGroupByKey={GROUP_BY_OBJECTIVE_KEY_OBJ}
      selectedSplitByKey={SPLIT_BY_NONE_KEY_OBJ}
      selectedTimeBoundPeriods={selectedTimelines}
      tagId={clickThroughViewData?.parentUuid}
    />
  );
};

export default ClickThroughObjectiveTable;
